(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagParticipantPersonDialogController', OrderBagParticipantPersonDialogController);

    OrderBagParticipantPersonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ParticipantPerson', 'PersonInfo', 'OrderBagServiceItemDtail'];

    function OrderBagParticipantPersonDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ParticipantPerson, PersonInfo, OrderBagServiceItemDtail) {
        var vm = this;
        vm.scope = $scope;
        vm.participantPerson = entity;
        vm.clear = clear;
        vm.save = save;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                onSaveSuccess(vm.participantPerson);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
